// How the CRM signs in with Google (#1479). Phones and tablets go by redirect: before it calls
// window.open, signInWithPopup waits on the auth iframe and an App Check token, and on iOS that
// wait loses the tap, so no popup opens. Desktop browsers keep the popup.

const MOBILE_USER_AGENT = /iPhone|iPad|iPod|Android|Mobi/i;

export function prefersRedirectSignIn({ userAgent = "", maxTouchPoints = 0 } = {}) {
  if (MOBILE_USER_AGENT.test(userAgent)) return true;
  // iPadOS sends a Mac user agent; only its touch points tell it from a Mac.
  return /Macintosh/.test(userAgent) && maxTouchPoints > 1;
}

// A second tap starts a new sign-in, which cancels the one still pending with this code. The newer
// one reports its own outcome, so this one has nothing to show.
export function isSupersededSignIn(error) {
  return error?.code === "auth/cancelled-popup-request";
}
